import Model from "../Model";

export interface TApplicantsAppointment {
  id: number;
  positionTypeId: number;
  sourceData: string;
  description?: string;
  appointmentDate: Date;
  startMandate: Date;
  predictedEnd?: Date;
  endMandate?: Date;
  applicantId: number;
  positionTypeName: string;
  appointmentValid: boolean;
  applicantsAppointmentId: number;
  appointmentId: number;
  institutionName?: string;
  mandateEndReason?: string;
}

export interface IApplicantsAppointment extends TApplicantsAppointment {}

const ApplicantsAppointment = Model(
  (model: TApplicantsAppointment): IApplicantsAppointment => {
    const _applicantsAppointment: TApplicantsAppointment = Object.assign(
      {},
      model
    );

    return {
      get id() {
        return _applicantsAppointment.id;
      },

      get positionTypeId() {
        return _applicantsAppointment.positionTypeId;
      },

      set positionTypeId(value: any) {
        _applicantsAppointment.positionTypeId = value;
      },

      get sourceData() {
        return _applicantsAppointment.sourceData;
      },

      set sourceData(value: any) {
        _applicantsAppointment.sourceData = value;
      },

      get description() {
        return _applicantsAppointment.description;
      },

      set description(value: any) {
        _applicantsAppointment.description = value;
      },

      get appointmentDate() {
        return _applicantsAppointment.appointmentDate;
      },

      set appointmentDate(value: any) {
        _applicantsAppointment.appointmentDate = value;
      },

      get startMandate() {
        return _applicantsAppointment.startMandate;
      },

      set startMandate(value: any) {
        _applicantsAppointment.startMandate = value;
      },

      get predictedEnd() {
        return _applicantsAppointment.predictedEnd;
      },

      set predictedEnd(value: any) {
        _applicantsAppointment.predictedEnd = value;
      },

      get endMandate() {
        return _applicantsAppointment.endMandate;
      },

      set endMandate(value: any) {
        _applicantsAppointment.endMandate = value;
      },

      get applicantId() {
        return _applicantsAppointment.applicantId;
      },

      set applicantId(value: any) {
        _applicantsAppointment.applicantId = value;
      },

      get positionTypeName() {
        return _applicantsAppointment.positionTypeName;
      },

      set positionTypeName(value: any) {
        _applicantsAppointment.positionTypeName = value;
      },

      get appointmentValid() {
        return _applicantsAppointment.appointmentValid;
      },

      set appointmentValid(value: any) {
        _applicantsAppointment.appointmentValid = value;
      },

      get applicantsAppointmentId() {
        return _applicantsAppointment.applicantsAppointmentId;
      },

      set applicantsAppointmentId(value: any) {
        _applicantsAppointment.applicantsAppointmentId = value;
      },

      get appointmentId() {
        return _applicantsAppointment.appointmentId;
      },

      get institutionName() {
        return _applicantsAppointment.institutionName;
      },

      get mandateEndReason() {
        return _applicantsAppointment.mandateEndReason;
      }
    };
  }
);

export default ApplicantsAppointment;
